export default __webpack_public_path__ + "static/media/gcwww.4ad0d138.png";